import { useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import ChartTable from "@/components/ChartTable";
import { Search } from "lucide-react";

export default function SearchCharts() {
  const [q, setQ] = useState("");
  const [charts, setCharts] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  const run = async (e) => {
    e?.preventDefault();
    setLoading(true);
    const { data } = await api.get("/charts", { params: q ? { search: q } : {} });
    setCharts(data);
    setSearched(true);
    setLoading(false);
  };

  return (
    <div className="p-6 md:p-10 max-w-6xl mx-auto" data-testid="search-charts-page">
      <PageHeader title="Search Charts" subtitle="Find by chart ID or patient name." />

      <form onSubmit={run} className="flex gap-2 mb-6" data-testid="search-form">
        <div className="relative flex-1">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input data-testid="search-input" value={q} onChange={(e) => setQ(e.target.value)}
                 placeholder="Search by chart ID or patient name…"
                 className="w-full border border-slate-300 rounded-lg pl-9 pr-3 py-2.5 text-sm focus:ring-2 focus:ring-sky-500 outline-none"/>
        </div>
        <button data-testid="search-submit-btn" className="bg-sky-700 text-white rounded-lg px-4 text-sm font-medium hover:bg-sky-600">
          Search
        </button>
      </form>

      {loading ? <div className="text-slate-500 py-8 text-center">Searching…</div> :
        searched ? <ChartTable charts={charts} emptyMsg="No results match your search." /> :
        <div className="text-slate-500 py-8 text-center">Enter a query above to search.</div>}
    </div>
  );
}
